// Free shipping bar for carts in a local currency (snippets/cart-summary.liquid).
// The regions' amounts are in the store currency, like the Free shipping discounts' minimums.
// Shopify converts those minimums at checkout with the store's exchange rate, so the bar converts
// with the same rate (Shopify.currency.rate) and writes its text and progress here. Liquid has no
// exchange rate, so it only renders the numbers this needs.
(() => {
  if (customElements.get('eg-free-ship')) return;

  // The theme prints 12345.67 in the cart currency as the money sample ("$12,345.67",
  // "12.345,67 €", "¥12,346"…); amounts are printed the same way.
  function moneyFormatter(sample) {
    const match = sample.match(/\d(?:[\d.,'\s]*\d)?/);
    if (!match) return null;
    const number = match[0];
    const decimals = /[.,]67$/.test(number) ? 2 : 0;
    const decimalMark = decimals ? number.charAt(number.length - 3) : '';
    const whole = decimals ? number.slice(0, -3) : number;
    const group = whole.replace(/\d/g, '').charAt(0);

    return (cents) => {
      const [int, fraction] = (cents / 100).toFixed(decimals).split('.');
      const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, group);
      return sample.split(number).join(fraction ? grouped + decimalMark + fraction : grouped);
    };
  }

  class EgFreeShip extends HTMLElement {
    connectedCallback() {
      this.update();
      // The cart drawer morphs this element on every cart change; redo the numbers after it.
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this, { attributes: true, childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    update() {
      const currency = window.Shopify?.currency;
      const rate = Number(currency?.rate);
      const base = Number(this.dataset.base);
      const total = Number(this.dataset.total);
      const format = moneyFormatter(this.dataset.sample || '');
      const text = this.querySelector('.eg-free-ship__text');
      const fill = this.querySelector('.eg-free-ship__fill');

      if (!(rate > 0) || !(base > 0) || !(total >= 0) || !format || !text || !fill || currency.active !== this.dataset.currency) {
        if (!this.hidden) this.hidden = true;
        return;
      }

      const threshold = Math.round(base * rate);
      const done = total >= threshold;
      const message = done
        ? this.dataset.done || ''
        : (this.dataset.message || '').split('[amount]').join(format(threshold - total));
      const progress = `${done ? 100 : Math.floor((total * 100) / threshold)}%`;

      if (text.textContent !== message) text.textContent = message;
      if (fill.style.getPropertyValue('--eg-free-ship-progress') !== progress) {
        fill.style.setProperty('--eg-free-ship-progress', progress);
      }
      this.classList.toggle('eg-free-ship--done', done);
      if (this.hidden) this.hidden = false;
    }
  }

  customElements.define('eg-free-ship', EgFreeShip);
})();
